import React, { useEffect, useState } from 'react';
import {
  Alert, Container, Spinner, Table,
} from 'react-bootstrap';
import axios from 'axios';
import UnifyButton from '../../../components/Button';
import { N0 } from '../../../components/Colors';
import NavbarAdmin from '../../../components/Navbar';
import Header from '../../../components/Header';
import AddAdmin from './Modals/AddAdmin';
import DeleteAdmin from './Modals/DeleteAdmin';
import { Loader } from './styles';
import config from '../../../config';

const TambahAdmin = () => {
  const [showAdd, setShowAdd] = useState(false);
  const [showDel, setShowDel] = useState(false);
  const [alert, setAlert] = useState({ type: '', message: '' });
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(true);
  const [admin, setAdmin] = useState({});

  const fetch = () => {
    setLoading(true);
    axios.get(`${config.API_BASE_URL}api/account/get-admin-list/`, {
      headers: {
        'content-type': 'application/json',
        accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    })
      .then((resp) => {
        setAdmins(resp?.data);
        setLoading(false);
      });
  };

  const handleCloseAdd = () => setShowAdd(false);
  const handleShowAdd = () => {
    setShowAdd(true);
  };

  const handleCloseDel = () => setShowDel(false);

  const handleShowDel = (selectedAdmin) => {
    setAdmin(selectedAdmin);
    setShowDel(true);
  };

  useEffect(() => {
    fetch();
  }, []);

  if (loading) {
    return (
      <Loader>
        <Spinner animation="border" />
      </Loader>
    );
  }
  return (
    <>
      <NavbarAdmin />
      <Header />
      <Container>
        <h2 className="mt-4 mb-4 text-center">List Admin</h2>
        {alert.message && <Alert variant={alert.type === 'success' ? 'success' : 'danger'}>{alert.message}</Alert>}
        <UnifyButton color="#24A0ED" textColor={N0} style={{ marginLeft: 'auto', marginBottom: 30 }} onClick={handleShowAdd}> + Tambah Admin</UnifyButton>
        <Table className="mt-4" striped bordered hover>
          <thead>
            <tr>
              <th>No</th>
              <th>Nama Admin</th>
              <th>Username Admin</th>
              <th>NIP</th>
              <th>Aksi Tersedia</th>
            </tr>
          </thead>
          <tbody>
            {admins.map((value, index) => (
              <tr>
                <td>{index + 1}</td>
                <td>{value.name}</td>
                <td>{value.username}</td>
                <td>{value.npmnip}</td>
                <td>
                  <UnifyButton className="mx-auto" color="#B23B3B" textColor={N0} onClick={() => handleShowDel(value)}>Hapus</UnifyButton>
                </td>

              </tr>
            ))}
          </tbody>
        </Table>
      </Container>
      <AddAdmin show={showAdd} handleClose={handleCloseAdd} setAlert={setAlert} refetch={fetch} />
      <DeleteAdmin
        show={showDel}
        handleClose={handleCloseDel}
        setAlert={setAlert}
        admin={admin}
        refetch={fetch}
      />
    </>
  );
};

export default TambahAdmin;
